import indexPageConstants from 'modules/indexPage/config/indexPageConstants'
const indexPages = [
  indexPageConstants.TYPE_HOME,
  indexPageConstants.TYPE_NEWS,
  indexPageConstants.TYPE_CHILDREN,
  indexPageConstants.TYPE_DRAMA,
  indexPageConstants.TYPE_PROGRAM,
  indexPageConstants.TYPE_APP,
]

export default {
  admin: [
    {
      icon: 'fa fa-window-restore',
      label: 'module.index-page',
      group: [
        {
          label: '版型',
          route: {
            name: 'admin.config.theme',
          },
          roles: ['ROLE_ADMIN', 'ROLE_INDEX_PAGE'],
        },
        ...indexPages.map(page => ({
          label: `index_page.data.type.${page}`,
          route: {
            name: 'admin.index-page-update',
            params: { id: page },
          },
          roles: ['ROLE_ADMIN', 'ROLE_INDEX_PAGE'],
        })),
      ],
    },
  ],
}